import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';

import { RepeatOrderAggregationRequest } from '../components/repeat-order/pages/abstract-repeat-order-page-component.directive';
import { repeatOrdersRequest } from '../store/actions';

export const repeatOrdersGuard: CanActivateFn = () => {
  inject(Store).dispatch(repeatOrdersRequest({ aggregationType: RepeatOrderAggregationRequest.none }));

  return true;
};
